import equalByNameAndAssetComponentId from '../../utils/equalByNameAndAssetComponentId';
import { i18n } from "../../../vue-i18n";
import dateConverter from "../../../../utils/converters/date.converter";

export default class SetDevaluations {
  constructor(assetComponentId, devaluations, currencyCode) {
    this.commandName = "SetDevaluations";

    this.assetComponentId = assetComponentId;
    this.devaluations = devaluations;

    if(this.devaluations.length !== 0) {
      let devaluationsForDescription = this.devaluations.map(function(item) {
        const convertedDate = dateConverter.convertToDate(item.startDate);
        return `${i18n.d(convertedDate)} - ${item.sum} ${currencyCode}`
      });

      this.description = devaluationsForDescription.join(', ');
    } else {
      this.description = '';
    }
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        AssetComponentId: this.assetComponentId,
        NewDevaluations: this.devaluations
      })
    }
  }

  equal = (other) => equalByNameAndAssetComponentId(this, other);
}
